module.exports = __webpack_public_path__ + "static/media/Moj-5.dda5f0c0.PNG";